import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "d-block col-md-2 ps-0" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "d-block pt-4 col-md-8 pt-md-0 px-0 ps-md-4 text-start" }
const _hoisted_7 = { class: "d-block col-md-2 pe-0" }
const _hoisted_8 = ["onClick"]

import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import SubSection from "../common/SubSection.vue";
import Monitoring from "@/guiide/ts/monitoring/monitoring";
import { AnnuityProviderResponse } from "@/guiide/ts/response/annuityProviderResponse";
import { app } from "@/guiide/ts/app";


export default /*@__PURE__*/_defineComponent({
  __name: 'AnnuityProvidersList',
  setup(__props) {

const store = useStore();
const providers = computed<Array<AnnuityProviderResponse>>(() => store.state.annuityProviders);

onMounted(() => {
    if (providers.value == null || providers.value.length == 0) {
        app.getAnnuityProviders();
    }
});

function onFindAdviceClick(providerKey: string) {
    const provider = providers.value.find(p => p.key == providerKey);
    const potsValue = store.state.retiree?.pensionPots.presentValue ?? 0;
    Monitoring.gaEvent('GInPrv' + provider.name.replace(' ', ''), potsValue);
    window.open(provider.url, "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SubSection, {
        title: "If you want to consider buying some guaranteed income",
        "show-help": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providers.value, (provider) => {
              return (_openBlock(), _createElementBlock("div", {
                key: provider.key,
                class: "row pt-3"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: provider.image,
                    class: "w-100",
                    alt: provider.name
                  }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provider.description, (descriptionPart, i) => {
                    return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(descriptionPart), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-sm float-end",
                    onClick: ($event: any) => (onFindAdviceClick(provider.key))
                  }, "Get quotes", 8, _hoisted_8)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})